import { InjectionToken } from '@angular/core';
import { OptimoveSdkConfigsLoader } from './types';
// eslint-disable-next-line @typescript-eslint/naming-convention
export const OPTIMOVE_SDK_CONFIG_LOADER: InjectionToken<OptimoveSdkConfigsLoader> =
  new InjectionToken<OptimoveSdkConfigsLoader>('optimoveSdkConfigs');
